/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_bu_dashboard_dashboard_business_unit_post } from '../models/Body_bu_dashboard_dashboard_business_unit_post';
import type { Body_get_invoice_complexity_report_data_dashboard_invoice_complexity_post } from '../models/Body_get_invoice_complexity_report_data_dashboard_invoice_complexity_post';
import type { Body_get_invoices_operations_report_data_dashboard_invoices_operations_post } from '../models/Body_get_invoices_operations_report_data_dashboard_invoices_operations_post';
import type { Body_supplier_dashboard_dashboard_supplier_post } from '../models/Body_supplier_dashboard_dashboard_supplier_post';
import type { Body_team_reviewer_dashboard_dashboard_team_reviewer_post } from '../models/Body_team_reviewer_dashboard_dashboard_team_reviewer_post';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * Get Invoices Operations Report Data
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getInvoicesOperationsReportDataDashboardInvoicesOperationsPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        requestBody?: Body_get_invoices_operations_report_data_dashboard_invoices_operations_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/invoices_operations',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Invoice Complexity Report Data
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getInvoiceComplexityReportDataDashboardInvoiceComplexityPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        requestBody?: Body_get_invoice_complexity_report_data_dashboard_invoice_complexity_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/invoice_complexity',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Supplier Dashboard
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static supplierDashboardDashboardSupplierPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        requestBody?: Body_supplier_dashboard_dashboard_supplier_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/supplier',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bu Dashboard
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static buDashboardDashboardBusinessUnitPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        requestBody?: Body_bu_dashboard_dashboard_business_unit_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/business_unit',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Team Reviewer Dashboard
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static teamReviewerDashboardDashboardTeamReviewerPost(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
        requestBody?: Body_team_reviewer_dashboard_dashboard_team_reviewer_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/team_reviewer',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Business Unit Name List
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static businessUnitNameListDashboardBusinessUnitNameGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/business_unit_name',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Supplier Name List
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static supplierNameListDashboardSupplierNameGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/supplier_name',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Invoice Status List
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static invoiceStatusListDashboardInvoiceStatusListGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/invoice_status_list',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Invoice Rejectionreason List
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static invoiceRejectionreasonListDashboardInvoiceRejectionreasonListGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/invoice_rejectionreason_list',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Invoice Invoicetype List
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static invoiceInvoicetypeListDashboardInvoiceInvoicetypeListGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/invoice_invoicetype_list',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Teams Lists
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns string Successful Response
     * @throws ApiError
     */
    public static teamsListsDashboardTeamsListGet(
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/teams_list',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Fetch And Update Reporting Dashboard
     * Fetch reporting dashboard data and update shared_at timestamp.
     * This replaces the stored procedure fetch_and_update_reporting_dashboard.
     * @param businessUnit Business unit code
     * @param accessToken Optional SSO Bearer token
     * @param xAuthorization
     * @param xGoogIapJwtAssertion
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static fetchAndUpdateReportingDashboardDashboardReportingDashboardFetchAndUpdateGet(
        businessUnit: string,
        accessToken?: string,
        xAuthorization?: (string | null),
        xGoogIapJwtAssertion?: (string | null),
        authorization?: (string | null),
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/reporting_dashboard/fetch_and_update',
            headers: {
                'x-authorization': xAuthorization,
                'x-goog-iap-jwt-assertion': xGoogIapJwtAssertion,
                'authorization': authorization,
            },
            query: {
                'business_unit': businessUnit,
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
